import React from "react";
import { Card, Icon } from "@blueprintjs/core";
import Flexbox from "flexbox-react";

import { FilledButton } from "../buttons-20250224T111359Z-001/buttons";

const AcknowledgementTabContent = ({
  acknowledgementData,
  onAcknowledge
}) => {

  const isAcknowledged =
    acknowledgementData?.is_acknowledged;

  return (
    <Card
      style={{
        padding: "34px",
         width: "100% !important",
        borderRadius: "18px",
        border: "1px solid #E5E7EB",
        background: "#FFFFFF",
        boxShadow: "0 2px 10px rgba(15, 23, 42, 0.05)"
      }}
    >
      <Flexbox
        style={{
          gap: "22px",
          alignItems: "flex-start"
        }}
      >

        {/* Left Icon */}
        <div
          style={{
            minWidth: "64px",
            width: "64px",
            height: "64px",
            borderRadius: "50%",
            background: isAcknowledged ? "#ECFDF3" : "#EEF2FF",
            border: isAcknowledged
              ? "1px solid #BBF7D0"
              : "1px solid #C7D2FE",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icon
            icon={isAcknowledged ? "endorsed" : "clipboard"}
            size={30}
            color={isAcknowledged ? "#16A34A" : "#4F46E5"}
          />
        </div>

        {/* Right Content */}
        <Flexbox
          flexDirection="column"
          style={{
            flex: 1,
            gap: "18px"
          }}
        >
          <div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: 700,
                color: "#111827",
                lineHeight: "36px"
              }}
            >
              {isAcknowledged
                ? "Acknowledgement Completed"
                : "Performance Review Acknowledgement"}
            </div>

            <div
              style={{
                color: "#4B5563",
                fontSize: "15px",
                lineHeight: "28px",
                maxWidth: "950px"
              }}
            >
              {isAcknowledged
                ? "Your acknowledgement for this review stage has been successfully recorded and processed within the performance review workflow. All required actions for this step have been completed and the review process has moved to the next stage."
                : "Please review and acknowledge this stage of the performance review process. Once acknowledged, the workflow will automatically proceed to the next review stage."}
            </div>
          </div>

          {isAcknowledged ? (
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                background: "#F0FDF4",
                border: "1px solid #BBF7D0",
                color: "#15803D",
                padding: "12px 18px",
                borderRadius: "12px",
                fontSize: "14px",
                fontWeight: 600,
                width: "fit-content"
              }}
            >
              <Icon icon="tick-circle" size={16} />

              Successfully acknowledged and processed by

              <span style={{ fontWeight: 700 }}>
                {acknowledgementData?.acknowledged_by}
              </span>
            </div>
          ) : (
            <div>
              <FilledButton
                text="Acknowledge & Continue"
                onClick={onAcknowledge}
                style={{
                  height: "44px",
                  padding: "0 22px",
                  fontSize: "14px",
                  fontWeight: 600,
                  borderRadius: "10px"
                }}
              />
            </div>
          )}
        </Flexbox>
      </Flexbox>
    </Card>
  );
};

export default AcknowledgementTabContent;
